import { render, staticRenderFns } from "./informationFeedback.vue?vue&type=template&id=400341de&scoped=true&"
import script from "./informationFeedback.vue?vue&type=script&lang=js&"
export * from "./informationFeedback.vue?vue&type=script&lang=js&"
import style0 from "./informationFeedback.vue?vue&type=style&index=0&id=400341de&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "400341de",
  null
  
)

export default component.exports